import { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import useInfraStores from '@app/hooks/useInfraStores';
import AuthenticatedMode from '@app/login/AuthenticatedMode';
import config from '@app/config';
import KnoxersManager from '@app/utils/knoxersManager';
import { isLocalhost } from '@app/utils/browserUtils';

const WorkCanvasLink: FC = observer(() => {
  const { authenticationStore, userStore } = useInfraStores<AuthenticatedMode>();
  const history = useHistory();

  useEffect(() => {
    const canvasUrl = config.webUrls?.canvas;
    if (!canvasUrl) {
      console.error('Canvas URL not configured');
      return;
    }

    if (authenticationStore.isLoggedIn) {
      if (userStore?.currentSecretId) {
        KnoxersManager.save(userStore.currentSecretId);
      }

      // On localhost, pass auth data via URL parameter since localStorage can't be shared across ports
      let finalCanvasUrl = canvasUrl;
      if (isLocalhost()) {
        const authData = KnoxersManager.getAuthDataAsUrlParam();
        if (authData) {
          const separator = canvasUrl.includes('?') ? '&' : '?';
          finalCanvasUrl = `${canvasUrl}${separator}auth=${authData}`;
        }
      }

      window.location.replace(finalCanvasUrl);
    } else {
      const returnUrl = encodeURIComponent(canvasUrl);
      history.push(`/login?returnUrl=${returnUrl}`);
    }
  }, [authenticationStore, userStore, history]);

  return null;
});

export default WorkCanvasLink;
